import React from "react";
import DatePicker from "../../../../../common/datepicker/DatePicker";
import InputBox from "../../../../../common/input/InputBox";
import TextAreaBox from "../../../../../common/input/TextAreaBox";
import TextAreaWithSpeech from "../../../../../common/input/TextAreaWithSpeech";

const PaymentInfo = ({ formik, edit, details, history, discountInput }) => {
  // Sum the four tender splits → amountPaid. Balance is computed by the
  // parent component's `calculateBalance` effect, so we intentionally
  // don't return it here; the earlier contract pretended to return a
  // `balance` that callers destructured but never used.
  const sumAmountPaid = (cash, card, upi, bank, existingAmountPaid = 0) =>
    cash + card + upi + bank + existingAmountPaid;

  const handlePaymentChange = (paymentType, e) => {
    // Get current values from formik
    const cashValue = formik.values.paymentIn.cash || 0;
    const cardValue = formik.values.paymentIn.card || 0;
    const upiValue = formik.values.paymentIn.upi || 0;
    const bankTransferValue = formik.values.paymentIn.bankTransfer || 0;

    // Store the updated value in a temporary variable
    const updatedValue = parseFloat(e.target.value) || 0;

    // Update the specific payment type value
    formik.setFieldValue(
      `paymentIn.${paymentType}`,
      parseFloat(e.target.value),
    );

    const amountPaid = sumAmountPaid(
      paymentType === "cash" ? updatedValue : cashValue,
      paymentType === "card" ? updatedValue : cardValue,
      paymentType === "upi" ? updatedValue : upiValue,
      paymentType === "bankTransfer" ? updatedValue : bankTransferValue
    );

    formik.setFieldValue("paymentIn.amountPaid", amountPaid);
  };

  const handleDiscountChange = (event) => {
    const discount = parseFloat(event.target.value) || null; // Parse the discount as a float, default to 0 if not a valid number
    formik.setFieldValue("discount", discount);
  };

  // ...

  return (
    <div className="shadow-card rounded-15">
      <div
        className={`shadow-card rounded-tl-15 rounded-tr-15 bg-secondary p-2 pl-4 text-bodyBB text-darkgrey mb-2 flex flex-wrap gap-2 items-center justify-between`}
      >
        <div>Payment Info</div>
        <div className="w-full sm:w-auto">
          <DatePicker
            className={"!h-[40px] w-full sm:!w-[260px] text-bodyRB"}
            onDateChange={(e) => {
              formik.setFieldValue("paymentIn.date", e);
            }}
            startDate={formik.values?.paymentIn?.date}
            error={
              formik.touched?.paymentIn?.date && formik.errors?.paymentIn?.date
            }
            disabled={!edit}
          />
        </div>
      </div>
      {/* Mobile-tight layout mirrors the medicine-bill PaymentInfo:
          - Both halves stack vertically (flex-col) with reduced padding.
          - Each half is a 2-col grid on every breakpoint so Cash/Card/UPI/
            Bank read two-per-row on mobile instead of one-per-line. */}
      <div className="flex flex-col lg:flex-row lg:justify-around p-3 sm:p-5 gap-3">
        <div className="grid grid-cols-2 gap-2 sm:gap-3 flex-1">
          <div>
            <p className="text-bodySB text-darkgrey pb-1">Cash</p>
            <InputBox
              type={"number"}
              name={`paymentIn.cash`}
              value={formik.values.paymentIn.cash ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("cash", e);
              }}
              error={
                formik.touched.paymentIn?.cash && formik.errors.paymentIn?.cash
              }
              disabled={!edit}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1">Card</p>
            <InputBox
              type={"number"}
              name={`paymentIn.card`}
              value={formik.values.paymentIn.card ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("card", e);
              }}
              error={
                formik.touched.paymentIn?.card && formik.errors.paymentIn?.card
              }
              disabled={!edit}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1">UPI</p>
            <InputBox
              type={"number"}
              name={`paymentIn.upi`}
              value={formik.values.paymentIn.upi ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("upi", e);
              }}
              error={
                formik.touched.paymentIn?.upi && formik.errors.paymentIn?.upi
              }
              disabled={!edit}
            />
          </div>
          <div className="">
            <p className="text-bodySB text-darkgrey pb-1">Bank Transfer</p>
            <InputBox
              type={"number"}
              name={`paymentIn.bankTransfer`}
              value={formik.values.paymentIn.bankTransfer ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("bankTransfer", e);
              }}
              error={
                formik.touched.paymentIn?.bankTransfer &&
                formik.errors.paymentIn?.bankTransfer
              }
              disabled={!edit}
            />
          </div>
          <div className="col-span-2">
            <p className="text-bodySB text-darkgrey pb-1">Notes</p>
            {/* <TextAreaBox
              className={""}
              name={`paymentIn.notes`}
              value={formik.values.paymentIn.notes}
              onChange={formik.handleChange}
              error={
                formik.touched.paymentIn?.notes &&
                formik.errors.paymentIn?.notes
              }
              disabled={!edit}
            /> */}

            <TextAreaWithSpeech
              className={""}
              name={`paymentIn.notes`}
              value={formik.values.paymentIn.notes}
              onChange={formik.handleChange}
              error={
                formik.touched.paymentIn?.notes &&
                formik.errors.paymentIn?.notes
              }
              disabled={!edit}
            />
          </div>
        </div>

        <div className="border-r-2 border-[#B9B9B9] hidden lg:block"></div>
        <div className="border-b-2 border-[#B9B9B9] block lg:hidden mt-1"></div>
        {/*  */}
        <div className="grid grid-cols-2 gap-2 sm:gap-3 h-fit flex-1">
          {!history && (
            <div>
              <p className="text-bodySB text-darkgrey pb-1">Discount</p>
              <InputBox
                type={"number"}
                name={`discount`}
                value={formik.values.discount ?? 0}
                onChange={handleDiscountChange}
                error={formik.touched.discount && formik.errors.discount}
                disabled={!edit}
              />
            </div>
          )}
          <div>
            <p className="text-bodySB text-darkgrey pb-1">Total Amount</p>
            <InputBox
              type={"number"}
              name={`total_amount`}
              value={formik.values.total_amount ?? 0}
              onChange={formik.handleChange}
              error={formik.touched.total_amount && formik.errors.total_amount}
              disabled={true}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1">Amount Paid</p>
            <InputBox
              className={"!bg-[#6AB483] !bg-opacity-[20%] font-semibold"}
              type={"number"}
              name={`paymentIn.amountPaid`}
              value={formik.values.paymentIn.amountPaid ?? 0}
              onChange={formik.handleChange}
              error={
                formik.touched.paymentIn?.amountPaid &&
                formik.errors.paymentIn?.amountPaid
              }
              // disabled={true}
              readOnly={true}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1 ">Balance Amount</p>
            <InputBox
              className={"bg-[#E45353] bg-opacity-[20%] font-semibold"}
              type={"number"}
              name={`balance`}
              value={formik.values.balance ?? 0}
              onChange={formik.handleChange}
              error={formik.touched.balance && formik.errors.balance}
              // disabled={true}
              readOnly={true}
            />
          </div>

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
